import { render, staticRenderFns } from "./Endnotenuebersicht.vue?vue&type=template&id=2ba5fc3a&scoped=true&"
import script from "./Endnotenuebersicht.vue?vue&type=script&lang=js&"
export * from "./Endnotenuebersicht.vue?vue&type=script&lang=js&"
import style0 from "./Endnotenuebersicht.vue?vue&type=style&index=0&id=2ba5fc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba5fc3a",
  null
  
)

export default component.exports